import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import translate from './translate';

function SearchInput(props) {
  const {
    id,
    placeholder,
    buttonText,
    value,
    handleTextValueChange,
    hasButton,
    reactToEnterPress,
    onSearchChange,
  } = props;

  const [inputValue, setInputValue] = useState(value);

  const handleButtonClick = useCallback(() => {
    handleTextValueChange(inputValue);
  }, [handleTextValueChange, inputValue]);

  const handleChange = useCallback(
    e => {
      const newVal = e.target.value;
      setInputValue(newVal);

      if (onSearchChange) {
        onSearchChange(newVal);
        return;
      }

      // If there's no button, propagate changes immediately
      if (!hasButton) {
        handleTextValueChange(newVal);
      }
    },
    [onSearchChange, hasButton, handleTextValueChange],
  );

  const handleKeyDown = useCallback(
    e => {
      if (reactToEnterPress && e.key === 'Enter') {
        handleButtonClick();
      }
    },
    [reactToEnterPress, handleButtonClick],
  );

  return (
    <div className="searchInputDiv">
      <input
        type="text"
        className="form-control m-input"
        placeholder={placeholder}
        id={id}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {hasButton && (
        <span className="searchInputButton">
          <button
            type="button"
            className="btn m-btn--pill btn-secondary"
            onClick={handleButtonClick}
          >
            {buttonText}
          </button>
        </span>
      )}
    </div>
  );
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  /** Input html placeholder */
  placeholder: PropTypes.string,
  /** onClick handler, the text is passed as an argument */
  handleTextValueChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func,
  /* Input html id */
  id: PropTypes.string,
  hasButton: PropTypes.bool,
  reactToEnterPress: PropTypes.bool,
};

SearchInput.defaultProps = {
  id: 'generalSearch',
  placeholder: 'Search ...',
  buttonText: null,
  hasButton: true,
  reactToEnterPress: false,
  onSearchChange: null,
};

export default translate(SearchInput);
